import { render, staticRenderFns } from "./Bargain.vue?vue&type=template&id=20b2f68e&"
import script from "./Bargain.vue?vue&type=script&lang=js&"
export * from "./Bargain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports